import React, { PureComponent } from 'react'
import * as R from 'ramda'

class Radio extends PureComponent {
    constructor(props) {
        super(props)

        if (typeof props.register === 'function') {
            props.register(props.name, this.validate)
        }
        this.state = {
            isInValid: false,
        }
    }

    componentWillUnmount() {
        const { unregister, name } = this.props

        if (typeof unregister === 'function') {
            unregister(name)
        }
    }

    onChange = () => {
        const { id, onBlur } = this.props

        if (typeof onBlur === 'function') {
            onBlur({ value: id, name: id })
        }
    }

    renderInput = () => {
        const {
            disabled, name, id, defaultChecked, placeholder, className, inputStyle, checked,
        } = this.props
        const { isInValid } = this.state

        let elem = ''

        if (!disabled) {
            elem = (
                <input
                    type="radio"
                    name={name}
                    id={`${name}|${id}`}
                    className={`form-radio ${isInValid ? 'validation-error' : ''} ${className}`}
                    onChange={this.onChange}
                    defaultChecked={defaultChecked}
                    checked={checked}
                    placeholder={placeholder}
                    style={inputStyle}
                />
            )
        } else if (defaultChecked) {
            elem = (
                <span className="form-radio"><i className="fal fa-check" /></span>
            )
        } else {
            elem = (
                <span className="form-radio" />
            )
        }

        return elem
    }

    render() {
        const {
            id, label, style, labelStyle, children, name,
        } = this.props
        return (
            <div style={{
                flex: 1, position: 'relative', display: 'flex', alignItems: 'center', ...style,
            }}
            >
                {this.renderInput()}
                {!R.isEmpty(label) && !R.isNil(label) && (
                    <label
                        htmlFor={`${name}|${id}`}
                        style={{
                            marginLeft: '10px', marginBottom: '0px', flex: 1, ...labelStyle,
                        }}
                    >
                        {label}
                    </label>
                )}
                {children}
            </div>
        )
    }
}

export default Radio
